import React from 'react';
import styled from "styled-components";

const CentroPantalla = styled.h2`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
` ;

export default class Unauthorized extends React.Component{
    render(){        
        return(       
            <CentroPantalla>
                <h2>Acceso no autorizado</h2>
            </CentroPantalla>
        );
    }
}